import { styled, Tooltip, useTheme } from '@mui/material'
import { StatusVariant, useOrderStatus } from 'ComponentLibrary/src/atoms/OrderStatus/useOrderStatus'
import { OrderStatus } from 'ComponentLibrary/src/common/order-status'

export type OrderStatusIconProps = {
    variant: StatusVariant
    state: OrderStatus
    size?: number | `${number}px`
    label?: string
}

export function OrderStatusIcon({ variant, state, size = '18px', label }: OrderStatusIconProps) {
    const theme = useTheme()
    const { getOrderStatusText, getOrderStatusIconColor, getOrderStatusIcon } = useOrderStatus()

    const Icon = getOrderStatusIcon(state, variant)
    const statusLabel = label ?? getOrderStatusText(state)

    if (variant === 'square') {
        return (
            <Tooltip title={statusLabel}>
                <SquareIconWrapper $color={getOrderStatusIconColor(state, 'square')} $size={size} role="status">
                    <Icon color={theme.palette.white} height="100%" width="100%" role="status-icon" />
                </SquareIconWrapper>
            </Tooltip>
        )
    }
    return (
        <Tooltip title={statusLabel}>
            <CircleIconWrapper $size={size} role="status">
                <Icon color={getOrderStatusIconColor(state, 'circle')} height="100%" width="100%" role="status-icon" />
            </CircleIconWrapper>
        </Tooltip>
    )
}

const SquareIconWrapper = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $color: string; $size: number | string }>(({ $color, $size }) => ({
    height: $size,
    width: $size,
    flexShrink: 0,
    backgroundColor: $color,
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}))

const CircleIconWrapper = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $size: number | string }>(({ $size }) => ({
    height: $size,
    width: $size,
    boxSizing: 'border-box',
}))
